import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Snackbar, Alert, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';

import { SearchAlertNotification } from '../../hooks/useSearchAlertHandling';

interface AlertSnackbarProps {
  notification: SearchAlertNotification;
  onClose: () => void;
}

export const AlertSnackbar = ({
  notification,
  onClose,
}: AlertSnackbarProps) => {
  const { T, locale } = useIntl();

  const handleClose = React.useCallback(
    (_: unknown, reason: string) => {
      if (reason === 'clickaway') {
        return;
      }
      onClose();
    },
    [onClose],
  );

  return (
    <Snackbar
      open={!!notification}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      onClose={handleClose}
    >
      <Alert
        icon={
          notification.severity === 'success' ? (
            <CheckCircleIcon fontSize="large" />
          ) : (
            <ErrorIcon fontSize="large" />
          )
        }
        severity={notification.severity}
      >
        <Typography variant="body2" color="secondary">
          {notification.message}
        </Typography>

        <NavLink.Anchor
          href={ROUTES.MyAlerts.getURL({}, locale)}
          variant="linkMedium"
          color="secondary"
        >
          {T('toast.saved_search.link_text')}
        </NavLink.Anchor>
      </Alert>
    </Snackbar>
  );
};
